app.directive('emitLastRepeaterElementImages', function() {
	return function($scope) {
		if ($scope.$last){
			$scope.$emit('LastRepeaterElementImages');
		}
	};
});


app.directive('emitLastRepeaterElementList', function() {
	return function($scope) {
		if ($scope.$last){
			$scope.$emit('LastRepeaterElementList');
		}
	};
});


app.directive('titleHeader', ['$timeout','$window', function ($timeout, $window) {
	return {
	  link: onTitleHeightChange,
	};

	function titleHeight($scope, element, attrs) {
		$timeout(function() {
			var titleHeight = element.height();
			$('.main').animate({
				'padding-top': titleHeight,
			},100);
		}, 0, false);
	}

	function onTitleHeightChange($scope, element, attrs) {
		$scope.$on('dataTitleHeaderLoaded', function() {
			titleHeight($scope, element, attrs);
		});

		angular.element($window).bind('resize', function(){
			titleHeight($scope, element, attrs);
		});
	}

}]);


app.directive('titleDetails', ['$timeout', function ($timeout) {
	return {
	  link: function ($scope, element, attrs) {
			$scope.$on('dataTitleDetailsLoaded', function() {
				$timeout(function() {
					var titleHeight = element.height();
					$('.main').animate({
						'padding-top': titleHeight,
					},100);
				}, 0, false);
			});
	  }
	};
}]);


app.directive('loading', ['$http', function ($http) {
  return {
    restrict: 'A',
    link: function ($scope, element, attrs) {
      $scope.isLoading = function () {
        return $http.pendingRequests.length > 0;
      };
      $scope.$watch($scope.isLoading, function(v) {
        if (v) {
          element.show();
        } else {
          element.hide();
        }
      });
    }
  };

}]);